import { StorageService } from './storage.service'
import { getConfig } from '@/config'
import packageJson from '../../package.json'

export class VersionService {
  private storage: StorageService
  private currentVersion: string

  constructor() {
    this.storage = new StorageService()
    this.currentVersion = packageJson.version
  }

  async checkVersion(): Promise<boolean> {
    const storedVersion = await this.storage.get<string>('app_version')
    
    if (!storedVersion || storedVersion !== this.currentVersion) {
      // Clear all cached data
      await this.storage.clear()
      
      // Store new version
      await this.storage.set('app_version', this.currentVersion)
      return true
    }
    
    return false
  }
} 